import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'components/common_v2/layouts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BodyLarge, BodyRegular } from 'components/common_v2/typography';

export const EmptyState = ({ icon, title, description }) => (
  <Box flexDirection="column" alignItems="center" marginTop="12px" style={{ height: '500px' }}>
    <FontAwesomeIcon icon={icon} color="black" size="2x" />
    <div style={{ textAlign: 'center' }}>
      <BodyLarge className="bold" style={{ margin: '12px 0px' }}>
        {title}
      </BodyLarge>
      <BodyRegular className="info">
        {description}
      </BodyRegular>
    </div>
  </Box>
);

EmptyState.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};


